<div class="game-wrapper" [class.shrink-mode]="data.shrinkMode">
    <h2 i18n [class.title-white]="data.title.isSpecial">{{ data.title.text }}</h2>

    <div class="sides">
        @for (side of data.sides; track side) {
        <div class="side side-{{ side.position }} state-{{ side.state }}">
            @for (hand of side.hands; track hand) {
            <div class="hand state-{{ hand.state }}">
                <div class="hand-content">
                    <div class="hand-amount">
                        <ng-container *ngIf="hand.amount.visible">{{ hand.amount.value }}</ng-container>
                    </div>
                    <div class="cards">
                        @for (card of hand.cards; track card) {
                        <app-card-holder [card]="data.cards[card.position]"></app-card-holder>
                        }
                    </div>
                    <!-- We need `data-text` for the text shadow -->
                    <div i18n class="hand-title" [attr.data-text]="hand.label" i18n-data-text>{{ hand.label }}</div>
                </div>
            </div>
            }
            <!-- We need `data-text` for the text shadow -->
            @if (side.label) {
            <div i18n class="side-title" [attr.data-text]="side.label" i18n-data-text>{{ side.label }}</div>
            }
        </div>
        }
    </div>
</div>
